import React, { Component } from 'react';

//import { ParallaxProvider, Parallax } from 'react-skrollr'
import Top from './components/Top';

import HvadErKultur from './components/HvadErKultur';
import HvadErRum from './components/HvadErRum';
import Workshop from './components/Workshop';
import HvadErUndervisning from './components/HvadErUndervisning';
import BagOm from './components/BagOm';
import GitteHenrik from './components/GitteHenrik';
import Kontakt from './components/Kontakt';
import Gallery from './components/Gallery';
import './App.css';

class App extends Component {
	render() {
		let compStyle = {
			'data-center-center': 'opacity: 1',
			'data-bottom-top': 'opacity: 0'
		}
		let style = {
			elm: {
				
				width: '100%',
				height: '100%'
			}
		}
		return (

			<div className='App' id='skrollr-body' >


					<div {...compStyle} style={style.elm}>
						<Top />
					</div>

					<div {...compStyle} style={style.elm}>
						<HvadErKultur />
					</div>

					<div {...compStyle} style={style.elm}>
						<HvadErUndervisning />
					</div>

					<div style={style.elm}>
						<Workshop />
					</div>

					<div {...compStyle} style={style.elm}>
						<HvadErRum />
					</div>

					<div style={style.elm}>
						<Gallery />
					</div>
					
					<div style={style.elm}>
						<BagOm />
					</div>

					<div {...compStyle} style={style.elm}>
						<GitteHenrik />
					</div>

					<div style={style.elm}>
						<Kontakt />
					</div>

			</div>

		);
	}
}






export default App;



// WEBPACK FOOTER //
// ./src/App.js